/**
 * État de la file de synchronisation, pour l'interface
 * (`ARCHITECTURE_V2.md` §3.5, étape 3).
 *
 * ⚠️ **`useSyncExternalStore` et non un `useState` + `useEffect`.** La file vit
 * hors de React — elle est réveillée par un événement `online`, par un retour au
 * premier plan, ou par le succès d'une requête, tous hors de tout rendu. C'est
 * exactement le cas que cette API existe pour couvrir, et elle évite le rendu
 * incohérent qu'un abonnement fait à la main produirait en mode concurrent.
 *
 * ⚠️ **Pas de bibliothèque d'état global** (règle n°7) : la file *est* le
 * magasin, et React s'y abonne. C'est le même parti pris que `lib/theme.ts` et
 * `lib/tabMemory.ts`.
 */

import { useSyncExternalStore } from 'react';

import { subscribeSync, syncState, type SyncState } from '../lib/syncQueue';

export function useSyncState(): SyncState {
  return useSyncExternalStore(
    (notify) => subscribeSync(() => notify()),
    syncState,
    /*
     * ⚠️ Même instantané côté serveur : il n'y a pas de rendu serveur dans ce
     * projet (l'archi §1.1 exclut le SSR), mais l'API exige l'argument et le
     * laisser absent lèverait au premier rendu hydraté si cela changeait un jour.
     */
    syncState,
  );
}
